// src/constants.ts

export const DROPDOWNTYPES = {
  // TYPE: "type",
  CHOOSE_PROFILE: "choose_profile",
  INTERESTED_IN: "interested_in",
  BUSINESS_INDUSTRY: "business_industry",
  BUSINESS_LOCATION: "business_location",
  BUSINESS_MODEL: "business_model",
  INVESTMENT_ROUND: "investment_round",
  NO_OF_EMPLOYEES: "no_of_employees",
  OPERATIONAL_REGION: "operational_region",
  CURRENT_ANNUAL_REVENUE: "current_annual_revenue",
  CAPITAL_OFFER_TYPE: "capital_offer_type",
  USE_OF_FUNDS: "use_of_funds",
  GLOBAL_TEAM_PRESENCE: "global_team_presence",
  ESTIMATED_FUNDING_TIMELINE: "estimated_funding_timeline",
  TRAGET_INVESTOR_PROFILE: "traget_investor_profile",
  BUSINESS_ENTITY_TYPE: "business_entity_type",
  DOCUMENTS: "documents",
  OWNERSHIP_TYPE: "ownership_type",
  TYPE_OF_BUSINESS_BEING_SOLD: "type_of_business_being_sold",
  REASON_FOR_SALE: "reason_for_sale",
  DEAL_TIMELINE_EXPECTATION: "deal_timeline_expectation",
  BUYER_PREFERENCE: "buyer_preference",
  TYPE_OF_SALE: "type_of_sale",
  PREFFERED_LOCATION: "preffered_location",
  STRATEGIC_ASSETS: "strategic_assets",
  BUSINESS_TYPE: "business_type",
  BUSINESS_SIZE: "business_size",
  TYPE_OF_PARTICIPANT: "type_of_participant",
  PRIMARY_OBJECTIVE: "primary_objective",
  INDUSTRY_SECTOR: "industry_sector",
  LANGUAGE_PREFERENCES: "language_preferences",
  PURPOSE_OF_NETWORKING: "purpose_of_networking",
  TYPE_OF_COLLABORATION: "type_of_collaboration",
  PREFERRED_TRADE_TERM: "preferred_trade_term",
  PROFILE_VISIBILITY: "profile_visibility",
  PREFERRED_COMMUNICATION: "preferred_communication",
  RATE_EFFECTIVENESS: "rate_effectiveness",
  RESOURCE_BENEFICIAL: "resource_beneficial",
  PREVIOUS_COLLABORATION: "previous_collaboration",
  DESIRED_NETWORK_OUTCOME: "desired_network_outcome",
  PREFERRED_NETWORK_FORMAT: "preferred_network_format",
  PRIORITY_LEVEL: "priority_level",
  INVESTMENT_AGE: "investment_age",
  DESIGNATION_ROLE: "designation_role",
  TYPICAL_INVESTMENT_RANGE: "typical_investment_range",
  INVESTMENT_INSTRUMENTS: "investment_instruments",
  TRAGET_DOMAINS: "traget_domains",
  LEVEL_OF_INVOLVEMENT: "level_of_involvement",
  ASSOCIATED_WITH: "associated_with",
  TYPE_OF_INSTITUTION_INVESTOR: "type_of_institution_investor",
  LOOKING_FOR_CONNECT: "looking_for_connect",
  PREFERRED_INVESTMENT_STAGES: "preferred_investment_stages",
  ASSETS_INCLUDED_IN_SALE: "assets_included_in_sale",
  INVESTMENT_EXPERIENCE: "investment_experience",
  MARKET_FOCUS: "market_focus",
  FUNDING_GOAL: "funding_goal",
};

export const ACCOUNT_TYPE = {
  "WANT-TO-GROW": "WANT_TO_GROW",
  "WANT-TO-SELL": "WANT_TO_SELL",
  INVESTMENT: "INVESTMENT",
} as const;
export const ACCOUNT_TYPE_API = {
  WANT_TO_GROW: "want-to-grow",
  WANT_TO_SELL: "want-to-sell",
  INVESTMENT: "investment",
} as const;

export const HELP_NAVIGATE = {
  INVESTMENT: "investment",
  "WANT-TO-SELL": "want-to-sell",
  WANT_TO_SELL: "want-to-sell",
  "WANT-TO-GROW": "want-to-grow",
  WANT_TO_GROW: "want-to-grow",
};

type AccountType = "WANT_TO_GROW" | "WANT_TO_SELL" | "INVESTMENT";

export const NEW_ACCOUNT_TYPE: Record<AccountType, string> = {
  WANT_TO_GROW: "global connect",
  WANT_TO_SELL: "business exchange",
  INVESTMENT: "capital bridge",
};

export const LOGIN_TYPE = {
  ENTREPRENEUR: "ENTREPRENEUR",
  INVESTOR: "INVESTOR",
  MENTOR: "MENTOR"
} as const;

export const DOCUMENT_TYPE = {
  BUSINES_PHOTO: "BUSINESS_PHOTO",
  VALUATION_REPORT: "VALUATION_REPORT",
  PITCH_DECK: "PITCH_DECK",
  VIDEO_DEMO_LINK: "VIDEO_DEMO_LINK",
  COMPANY_PROFILE_BROUCHER: "COMPANY_PROFILE_BROUCHER",
  CERTIFICATE_COMPLIANCE_DOCUMENTS: "CERTIFICATE_COMPLIANCE_DOCUMENTS",
  PRODUCT_SERVICE_CATALOG: "PRODUCT_SERVICE_CATALOG",
  BUSINESS_LICENSE: "BUSINESS_LICENSE",
  FINANCIAL_SUMMARY: "FINANCIAL_SUMMARY",
  EXECUTIVE_SUMMARY: "EXECUTIVE_SUMMARY",
  PRODUCT_DEMO: "PRODUCT_DEMO",
  FINANCIAL_REPORT: "FINANCIAL_REPORT",
  BUSINESS_PHOTO: "BUSINESS_PHOTO",
  ADDITIONAL_SUPPORTING_DOCUMENT: "ADDITIONAL_SUPPORTING_DOCUMENT",
};
export const NAVIGATION_CONST = {
  LOGIN: "LOGIN",
  REGISTRATION: "REGISTRATION",
  MY_PROFILE: "MY_PROFILE",
  SUBSCRIPTION: "SUBSCRIPTION",
};

export const CHAT_MESSAGE_TYPE = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  FILE: "FILE",
};

export const excludedDocKeys = [
  DOCUMENT_TYPE.BUSINES_PHOTO,
  DOCUMENT_TYPE.PITCH_DECK,
  DOCUMENT_TYPE.VALUATION_REPORT,
  DOCUMENT_TYPE.EXECUTIVE_SUMMARY,
  DOCUMENT_TYPE.FINANCIAL_REPORT,
  DOCUMENT_TYPE.PRODUCT_DEMO,
  DOCUMENT_TYPE.FINANCIAL_SUMMARY,
  DOCUMENT_TYPE.ADDITIONAL_SUPPORTING_DOCUMENT,
  DOCUMENT_TYPE.PRODUCT_SERVICE_CATALOG,
  DOCUMENT_TYPE.COMPANY_PROFILE_BROUCHER,
  DOCUMENT_TYPE.CERTIFICATE_COMPLIANCE_DOCUMENTS

];

export const SUBSCRIPTION_BUY_MODE = {
  NEW: "new",
  RENEW: "renew",
  ADDON: "addon",
  UPGRADE: "upgrade",
  CANCEL: "cancel",
};

export const META_CONST = {
  REGISTRATION_COMPLETE: "REGISTRATION_COMPLETE",
  LOGIN: "LOGIN",
  BUY_SUBSCRIPTION: "BUY_SUBSCRIPTION",
  INVESTOR_SEARCH: "INVESTOR_SEARCH",
  PROPOSAL_REQUEST: "PROPOSAL_REQUEST",
};

export const PROPOSAL_ACTIONS = {
  PROPOSAL_SENT: "PROPOSAL_SENT",
  ACCEPT_PROPOSAL: "ACCEPT PROPOSAL",
  REJECT_PROPOSAL: "REJECT_PROPOSAL",
};
